export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8546.d76f6b47.jpg";